import { inject } from 'vue';
import { UI_CONFIG_INJECTION_KEY, defaultUiConfig } from '../../shared/ui-config';
export function useUiConfig() {
  return inject(UI_CONFIG_INJECTION_KEY, defaultUiConfig);
}
